enum ButtonColor {
  BRAND = "#22a7f0",
  WHITE = "#ffffff",
  GRAY = "#73757a",
  GRAY_BORDER = "#A0A0A0",
}

export default ButtonColor
